<template>
    <div class="materials-list">
        <ul class="list-group">
            <li class="list-group-item" v-for="material in paginatedMaterials" :key="material.id">
                <div class="material">
                    <div class="material-left">
                        <a 
                            v-if="!isFavorite"
                            class="btn btn-link icon-star" 
                            :class="{favorite: isUserFavorite(material)}"
                            @click="favoriteMaterial(material)"
                        ></a>
                        <div 
                            v-else 
                            class="module-icons mr-3 favorites physical_activity" 
                            :class="getModuleStyle(material)"
                        ></div>
                        <div class="material-info">
                            <a v-if="material.is_video"
                                :href="'#'+material.main_link.url" 
                                @click="showVideo(material.main_link, material)"
                            >
                                {{material.name}}
                            </a>
                            <a v-else :href="`${$basePath}/tips-and-materials/${material.slug}?category_id=${category_id}&section_id=${section_id}`" target="material">{{material.name}}</a>

                            <small v-if="material.secondary_link">
                                (<a v-if="material.is_video"
                                    :href="'#'+material.secondary_link.url" 
                                    @click="showVideo(material.secondary_link, material)"
                                >
                                    Spanish version
                                </a>
                                <a v-else :href="`${$basePath}/tips-and-materials/${material.slug}?link=secondary&category_id=${category_id}&section_id=${section_id}`" target="material">Spanish version</a>)
                            </small>
                        </div>
                        <div class="material-link">
                            <a :href="material.source_url">{{material.source_name}}</a>
                            <span v-if="material.source_location">, {{material.source_location}}</span>
                        </div> 
                    </div>
                    <div class="material-tags">
                        <small v-for="(tag, idx) in material.tags" :key="tag.id">
                            <span v-if="idx > 0">,</span> 
                            <a class="material-tag" href="#">{{ tag.name.en.toUpperCase() }}</a>
                        </small>
                    </div>
                </div>
            </li>
        </ul>    
        <BPagination 
            class="mt-3 mx-3"
            size="md" 
            :total-rows="materials.length" 
            v-model="currentPage" 
            :per-page="pageSize"
            hide-goto-end-buttons
            prev-text="Previous"
            next-text="Next"
            v-if="materials.length > pageSize && paginated"
        ></BPagination>
        <video-modal :video="currentVideo" v-model="showVideoModal"></video-modal>
    </div>
</template>

<style lang="scss">
@import "../../../sass/variables";
@import "../../../sass/pages/tips_and_materials";
</style>

<script>
    import VideoModal from './VideoModal.vue'
    import Auth from '../../auth.js'

    export default {
        props: {
            materials: {
                required: true,
                type: Array
            },
            isFavorite: {
                type: Boolean,
                default: false
            },
            paginated: {
                type: Boolean,
                default: true
            },
            section_id:{
                required:false,
                default:null
            },
            category_id:{
                required:false,
                default:null
            }
        },
        components: {
            VideoModal
        },
        data() {
            return {
                currentVideo: [],
                showVideoModal: false,
                pageSize: 5,
                currentPage: 1,
                userFavorites: [],
            }
        },
        computed: {
            paginatedMaterials: function () {
                if (this.paginated) {
                    return this.materials.slice(this.pageOffset, (this.pageOffset+this.pageSize));
                }
                return this.materials
            },
            pageOffset: function () {
                return (this.currentPage-1)*this.pageSize;
            },
            $basePath() {
              return window.basePath;
            }
        },
        methods: {
            showVideo(video, material) {
                this.showVideoModal = true;
                this.currentVideo = video
                if (material) {
                    axios.get(`/tips-and-materials/${material.slug}?category_id=${this.category_id}&section_id=${this.section_id}`)
                }
            },
            getModuleStyle(material) {
                return '';
                const icon = material.sections[0].module.icon
                const style = (this.isUserFavorite(material)) ? 'favorite' : '';
                return style + ' ' + icon;
            },
            favoriteMaterial(material) {
                if (this.userFavorites.indexOf(material.id) == -1) {
                    return window.axios.post('/api/users/'+Auth.user.id+'/materials', {material_id: material.id})
                        .then((response) => {
                            this.userFavorites.push(response.data.material_id)
                        })
                        .catch((error) => console.log('error'));
                }
                return window.axios.delete('/api/users/'+Auth.user.id+'/materials/'+material.id)
                    .then((response) => this.userFavorites.splice(this.userFavorites.indexOf(material.id), 1))
                    .catch((error) => console.error(error))
            },
            isUserFavorite(material) {
                return this.userFavorites.indexOf(material.id) > -1
            }
        },
        mounted() {
            this.userFavorites = Auth.user.favorite_materials.map((item) => item.id);
        }
        //component definition
    }
</script>